import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const Arrow = ({
    points,
    onMouseOver,
    onMouseDown,
    className="",
    onMouseLeave,
    fill,
    opacity,
    stroke,
    strokeWidth}) => { 
        const fl = (x) => Math.floor(x);
        let d = "M " + fl(points[0]) + ' ' + fl(points[1]);
        let pts = "";
        for (let i=2 ; i < points.length - 1; i+=2) {
            pts += (fl(points[i]) + ',' + fl(points[i+1])) + ' ';
        }
        let u = d + " C " + pts;
    return (
        <path
          className={className}
          onMouseDown={onMouseDown}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
          d={u}
          stroke={stroke}
          strokeWidth={strokeWidth}
          opacity={opacity}
          fill="transparent"
          markerEnd="url(#arrowhead)"
          >
        </path>);
}
export default Arrow;
